module.exports = __webpack_public_path__ + "static/interstate-condensed-3da69e57f686f770120a9fb77f8aa1a9.woff";